module.exports = __webpack_public_path__ + "static/media/delete_icn.5da2b667.png";